import { Component, Prop, h, Fragment, Watch } from '@stencil/core';
import { GlobalProps, getGlobalPropsClasses } from '../../global/global-styles-helper';
import { AnimationProps, getAnimationClasses } from '../../global/animation-helpers';


@Component({
  tag: 'gov-button',
  styleUrl: 'gov-button.css',
  shadow: false,
})
export class GovButton implements GlobalProps, AnimationProps {

  @Prop() label: string | number;
  @Prop() icon: string;
  @Prop() hasSuffix: boolean = false;
  @Prop() hasPrefix: boolean = false;
  @Prop() size: string;
  @Prop() iconSize: 'sm' | 'md' | 'lg' = 'md';
  @Prop() type?: string;
  @Prop() variant: string;
  @Prop() clicked?: (event: MouseEvent) => void;
  @Prop() typeVariant: 'button' | 'textButton' | 'iconButton' = 'button'; // Add the typeVariant prop
  
  // Add the disabled prop
  @Prop() disabled: boolean = false;
  //Animations properties and provate var to attach to div
  @Prop() animation?: string;
  @Prop() animationDelay?: '2s' | '3s' | '4s' | '5s' = '2s';
  @Prop() animationSpeed?: 'slow' | 'slower' | 'fast' | 'faster';
  private allClasses = '';
  private sizes = ['sm', 'lg', 'extended'];
  private validVariants = ['primary', 'secondary', 'info', 'success', 'warning', 'danger', 'white', 'disabled'];


  //watching for any change in animations to trigger them
  @Watch('animation')
  watchAnimations() {
    this.provideClass();
  }
  @Watch('animationDelay')
  watchAnimationsDelay() {
    this.provideClass();
  }
  @Watch('animationSpeed')
  watchAnimationsSpeed() {
    this.provideClass();
  }


  // inject the animations and styles on component load
  componentWillLoad() {
    const animationClasses = getAnimationClasses({
      animation: this.animation, 
      animationDelay: this.animationDelay,
      animationSpeed: this.animationSpeed
    });
    
    this.allClasses = getGlobalPropsClasses({
      classes: ' '+ animationClasses,  
    });
  }

  //Called on change of any animation related property to trigger change
  provideClass(){
      const animationClasses = getAnimationClasses({
          animation: this.animation, 
          animationDelay: this.animationDelay,
          animationSpeed: this.animationSpeed
      });
      
      this.allClasses = getGlobalPropsClasses({
          classes:' '+ animationClasses, 
      
      });
  }

  render() {
    const sizeClass = this.sizes.includes(this.size) ? this.size : '';
    const variantClass = this.validVariants.includes(this.variant) ? this.variant : '';
    const typeVariantClass = this.typeVariant;

    // If the button is disabled, apply the 'disabled' class and prevent clicking
    const buttonClasses = `btn ${sizeClass} ${this.disabled ? 'disabled' : variantClass} ${typeVariantClass}`;
    
    return (
      <button 
        type={this.type} 
        class={`${buttonClasses} ${this.allClasses}`}  
        onClick={this.disabled ? undefined : this.clicked} 
        disabled={this.disabled}
      >
        {this.typeVariant === 'iconButton'&& this.icon != "" && <span class="">
          <gov-icon name={this.icon} size={this.iconSize == 'md' || 'lg' || 'sm' ? this.iconSize :'md'} variant={this.disabled ? 'disabled' : this.variant}></gov-icon>
        </span>}
        {this.typeVariant === 'button' && (
          < >
          <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
            {this.icon && this.hasPrefix && <span class="icon" style={{ marginRight: '8px', marginTop:'3px'}}>
              <gov-icon name={this.icon} size={this.iconSize == 'md' || 'lg' || 'sm' ? this.iconSize :'md'} variant={"white"}></gov-icon>
            </span>}
            {this.label && <span class="label">{this.label}</span>}
            {this.icon && this.hasSuffix && <span class="icon" style={{ marginLeft: '8px', marginTop:'3px'}}>
              <gov-icon name={this.icon} size={this.iconSize == 'md' || 'lg' || 'sm' ? this.iconSize :'md'} variant={"white"}></gov-icon>
            </span>}
          </div>
          </>
        )}
        {this.typeVariant === 'textButton' && <span class="label">{this.label}</span>}
      </button>
    );
  }
}